// src/Components/Carousel/img/data.js

// ------------------ IMAGE IMPORTS ------------------
import img1 from "../img/10001.jpg";
import img2 from "../img/10002.jpg";
import img3 from "../img/10003.jpg";
import img4 from "../img/10004.jpg";
import img5 from "../img/10005.jpg";// Amazon Basics


// ------------------ EXPORTS ------------------

// ✅ Carousel Data
export const carouselData = {
  Amazon_Basics: [img1, img2, img3, img4, img5],
  
};

// ✅ Lower Header Links
export const lowerHeaderLinks = [
  { name: "All", link: "/" },
  { name: "Today's Deals", link: "/deals" },
  { name: "Electronics", link: "/electronics" },
  { name: "Fashion", link: "/fashion" },
  { name: "Books", link: "/books" },
  { name: "Customer Service", link: "/customer-service" },
  { name: "Home & Kitchen", link: "/home-kitchen" },
  { name: "Toys & Games", link: "/toys-games" },
];
